import portsApi from '@/framework/ports/portsApi';

import { PortsSubscription } from './types';

const locationFns = {
  get: async (): Promise<URL> => {
    const locationHref = await portsApi.invoke('Location.get');
    return new URL(locationHref);
  },
  set: (path: string): void => {
    portsApi.invoke('Location.set', [path]);
  },
  replace: (path: string, removeHash?: boolean): void => {
    portsApi.invoke('Location.replace', [path, removeHash]);
  },
  replaceToExternalPage: (url: string): void => {
    portsApi.invoke('Location.replaceToExternalPage', [url]);
  },
  onUrlChange: (callback: (location: URL) => void): PortsSubscription => {
    return portsApi.on('Location.onUrlChange', callback);
  },
};

export default locationFns;
